import { render, staticRenderFns } from "./updateContract.vue?vue&type=template&id=ff1e70aa&scoped=true&"
import script from "./updateContract.vue?vue&type=script&lang=js&"
export * from "./updateContract.vue?vue&type=script&lang=js&"
import style0 from "./updateContract.vue?vue&type=style&index=0&id=ff1e70aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1e70aa",
  null
  
)

export default component.exports